const truthyFlag = (value: unknown): boolean =>
  ['1', 'true', 'yes', 'on'].includes(String(value ?? '').trim().toLowerCase())

export const shouldPostLocalDebugLog = (): boolean => {
  if (typeof window === 'undefined') return false
  try {
    const params = new URLSearchParams(window.location.search)
    const raw =
      params.get('fgLocalDebugIngest') ??
      params.get('fg_local_debug_ingest') ??
      window.localStorage.getItem('fg_local_debug_ingest') ??
      ''
    return truthyFlag(raw)
  } catch {
    return false
  }
}

export const postOptionalLocalDebugLog = (url: string, init: RequestInit): void => {
  if (!shouldPostLocalDebugLog()) return
  try {
    void fetch(url, init).catch(() => {})
  } catch {
    // ignore local debug logging failures
  }
}
